module.exports = __webpack_public_path__ + "static/media/DI.bc9f30e6.jpg";